import { api } from "@/lib/api";

export const P = (path, params) => api.get(`/ponto${path}`, { params }).then((r) => r.data);
export const fmtMin = (m) => {
  const v = Math.round(Number(m) || 0);
  const s = v < 0 ? "-" : "";
  const a = Math.abs(v);
  return `${s}${String(Math.floor(a / 60)).padStart(2, "0")}:${String(a % 60).padStart(2, "0")}`;
};
export const mesAtual = () => new Date().toISOString().slice(0, 7);
export const mesAnterior = () => {
  const d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() - 1);
  return d.toISOString().slice(0, 7);
};
export const DIAS_SEMANA = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];
export const diaSemana = (iso) => DIAS_SEMANA[(new Date(`${iso}T12:00:00`).getDay() + 6) % 7];
export const fmtCpf = (c = "") => c.replace(/\D/g, "").replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
export const FONTE = { O: "Relógio", I: "Incluída", P: "Pré-assinalada", X: "Exceção", T: "Outra" };
